import { ProblemLine } from "@/components/ui/Note";
import type { ProblemAsk } from "@/lib/problem/describe-problem";
import { useProblem } from "@/lib/problem/use-problem";

/**
 * A `ProblemLine` for a failed act, drawn only while `error` stands. `act` defaults to "save",
 * the act a line under a control most often reports.
 */
export function ProblemNote({
  error,
  onRetry,
  id,
  className,
  act = "save",
  ...ask
}: ProblemAsk & {
  error: unknown;
  onRetry?: () => void;
  id?: string;
  className?: string;
}) {
  const { problem, report } = useProblem(error, { ...ask, act });
  if (error === null || error === undefined) return null;
  return (
    <ProblemLine
      id={id}
      className={className}
      onRetry={onRetry}
      onReport={report}
    >
      {`${problem.title}. ${problem.reason}`}
    </ProblemLine>
  );
}
